import Utils from "../../services/Utils.js";
import { getMatch } from "../../js/api/singleMatch.js";
import {
  getSingleColumnModule,
  getInsideSingleColumn,
} from "../templates/singleColumnModule.js";
import { _t } from "../../services/TranslationService.js";
import { getUserGroup } from "../../services/UserGroup.js";
import { getSearchGames } from "../../js/api/search.js";
import { getSearchingGames } from "../templates/search-games.js";
import { isSportBlocked } from "../../services/BlockedSports.js";

var gameId = 0;
let groupMatchHomeName = "";
let groupMatchAwayName = "";
let matchSportName = "";
let matchCountryName = "";
let blockedSportRedirect = false;

let Match = {
  render: async () => {
    blockedSportRedirect = false;
    let request = Utils.parseRequestURL();
    if (request && request.query && request.query.today == 1) {
      localStorage.setItem("today", true);
    }

    let groupMatches = (await getMatch(request.id)) || [];
    gameId = request.id;

    if (groupMatches.length !== 0) {
      if (groupMatches[0] && groupMatches[0][0]) {
        if (isSportBlocked(groupMatches[0][0].sport_id)) {
          blockedSportRedirect = true;
          window.location.hash = "#/";
          return "";
        }

        localStorage.setItem("matchSport", groupMatches[0][0].sport_id);
      }

      matchSportName = groupMatches[0][0].sport_name || "";
      matchCountryName = groupMatches[0][0].country_name || "";
    } else {
      window.location.href = "#/";
    }

    let groupMatchView = "";
    let matchView = "";
    let scrollMeContent = "";

    let groupMatchDate = "";
    let acc = groupMatches.map(function (item) {
      return {
        mainCategoryID: item[0].mainCategoryID,
        market_id: item[0].mainCategoryID ? -1 : item[0].market_id,
        mainCategory: item[0].mainCategory,
      };
    });

    const uniqueCategories = [];

    $.each(acc, function (i, el) {
      const res = uniqueCategories.find(
        (a) =>
          a.mainCategoryID == el.mainCategoryID && a.market_id == el.market_id
      );
      if (!res) uniqueCategories.push(el);
    });

    uniqueCategories.forEach((category) => {
      let activeClass = "";
      if (scrollMeContent == "") activeClass = "active";

      scrollMeContent += `<a class="singleMatchCatBtn flex flex-row w-full flex-nowrap py-2 px-2 text-[12px] font-bold whitespace-nowrap justify-center items-center ${
        activeClass === "active"
          ? "text-white bg-[#81011e]"
          : "text-white/50 bg-black/40"
      }" data-target="${category.mainCategoryID}-module">${_t(
        category.mainCategory
      )}</a>`;
      matchView = "";
      const a = groupMatches.filter(
        (a) => a[0].mainCategoryID == category.mainCategoryID
      );

      groupMatchView += `<div class="singleMatchBetModule space-y-2 flex-row flex-wrap w-full ${
        activeClass === "active" ? "flex" : "hidden"
      }" data-content="${category.mainCategoryID}-module">`;

      a.map((groupMatch) => {
        if (groupMatch[0].order === null) {
          groupMatch[0].order = 9999999;
        }
        return groupMatch;
      })
        .sort((a, b) => Number(a[0].order) - Number(b[0].order))
        .forEach((groupMatch) => {
          groupMatchHomeName = `${groupMatch[0].home_team}`;
          groupMatchAwayName = `${groupMatch[0].away_team}`;
          groupMatchDate = `${groupMatch[0].game_date}`;

          var howtoproceed = 0;
          switch (groupMatch[0].market.toLowerCase()) {
            case "draw no bet":
              howtoproceed = 1;
              break;
          }
          var jsondata;

          const hasSpecialValue =
            groupMatch[0].special_value &&
            groupMatch[0].special_value != "" &&
            groupMatch[0].type_of_column;

          let classDescription = "";
          switch (groupMatch[0].type_of_column) {
            case 1:
              classDescription = hasSpecialValue
                ? "threeColumns"
                : "twoColumns";
              break;
            case 2:
              classDescription = hasSpecialValue
                ? "fourColumns"
                : "threeColumns";
              break;
            case 3:
              classDescription = hasSpecialValue
                ? "threeColumns"
                : "twoColumns";
              break;
            case 4:
              classDescription = hasSpecialValue
                ? "fourColumns"
                : "threeColumns";
              break;
            default:
              break;
          }

          if (groupMatch[0].type_of_column) {
            matchView += `<div class="singleHeaderHolderLabel bg-white/10 flex flex-wrap flex-row w-full">`;
            if (hasSpecialValue) {
              matchView += `<div class="singleHeaderLabel flex flex-wrap border-r border-[#3d3d3d] flex-row ${classDescription}"></div>`;
            }
            if (groupMatch[0].type_of_column == 1) {
              matchView += `<div class="singleHeaderLabel flex flex-wrap flex-row text-[11px] min-h-1 text-white truncate whitespace-nowrap overflow-hidden text-ellipsis px-1 border-r border-[#3d3d3d] ${classDescription}">Larte</div>`;
              matchView += `<div class="singleHeaderLabel flex flex-wrap flex-row text-[11px] min-h-1 text-white truncate whitespace-nowrap overflow-hidden text-ellipsis px-1 ${classDescription}">Poshte</div>`;
            }
            if (groupMatch[0].type_of_column == 2) {
              matchView += `<div class="singleHeaderLabel flex flex-wrap flex-row text-[11px] min-h-1 text-white truncate whitespace-nowrap overflow-hidden text-ellipsis ${classDescription}">Larte</div>`;
              matchView += `<div class="singleHeaderLabel flex flex-wrap flex-row text-[11px] min-h-1 text-white truncate whitespace-nowrap overflow-hidden text-ellipsis ${classDescription}">X</div>`;
              matchView += `<div class="singleHeaderLabel flex flex-wrap flex-row text-[11px] min-h-1 text-white truncate whitespace-nowrap overflow-hidden text-ellipsis ${classDescription}">Poshte</div>`;
            }
            if (groupMatch[0].type_of_column == 3) {
              matchView += `<div class="singleHeaderLabel flex flex-wrap flex-row text-[11px] min-h-1 text-white truncate whitespace-nowrap overflow-hidden text-ellipsis ${classDescription}">${groupMatchHomeName}</div>`;
              matchView += `<div class="singleHeaderLabel flex flex-wrap flex-row text-[11px] min-h-1 text-white truncate whitespace-nowrap overflow-hidden text-ellipsis ${classDescription}">${groupMatchAwayName}</div>`;
            }
            if (groupMatch[0].type_of_column == 4) {
              matchView += `<div class="singleHeaderLabel flex flex-wrap flex-row text-[11px] min-h-1 text-white truncate whitespace-nowrap overflow-hidden text-ellipsis ${classDescription}">${groupMatchHomeName}</div>`;
              matchView += `<div class="singleHeaderLabel flex flex-wrap flex-row text-[11px] min-h-1 text-white truncate whitespace-nowrap overflow-hidden text-ellipsis ${classDescription}">X</div>`;
              matchView += `<div class="singleHeaderLabel flex flex-wrap flex-row text-[11px] min-h-1 text-white truncate whitespace-nowrap overflow-hidden text-ellipsis ${classDescription}">${groupMatchAwayName}</div>`;
            }
            matchView += ` </div>`;
          }

          let currentSpecialValue = "";

          groupMatch.forEach((match) => {
            if (hasSpecialValue && match.special_value != currentSpecialValue) {
              matchView += `
                            <div class="singleColumnModule text-center labelBtn bg-white/5 text-white/50 truncate whitespace-nowrap overflow-hidden text-ellipsis text-[11px] mb-[1px] border-r border-[#3d3d3d] ${classDescription}">
                                <span>${match.special_value}</span>
                            </div>
                        `;
              currentSpecialValue = match.special_value;
            }

            jsondata = JSON.stringify(match);
            matchView += getSingleColumnModule(
              match,
              request,
              classDescription,
              hasSpecialValue
            );
          });

          groupMatchView += `
                    <div class="singleMatchBetModuleGroup flex flex-wrap flex-row w-full"  id="${
                      groupMatch[0].market_id
                    }">
                        <div class="singleMatchBetModuleGroupHeader flex flex-wrap flex-row w-full text-[11px] leading-[19px] font-normal text-left text-yellow-400 bg-black/70 items-center mb-[1px] space-x-1">
                            <img class="flex flex-wrap flex-row w-[19px] h-[19px]" src="./img/1.png" />
                            <span class="titleMarketSearch flex flex-wrap flex-row pt-[1px]">${_t(
                              groupMatch[0].market
                            )}</span>
                        </div>
                        <div class="singleMatchBetModuleGroupContent flex flex-row flex-wrap w-full" id="${
                          groupMatch[0].market_id
                        }-content">
                            ${matchView}
                        </div>
                    </div>
                `;
          matchView = "";
        });

      groupMatchView = groupMatchView + `</div>`;
    });

    let view = /*html*/ `
            <div class="bg-[rgba(0,0,0,0.2)] w-full flex flex-wrap flex-col opacity-0 duration-300 ease-in-out matchViewAll">
                <h2 class="hiddenMatch flex flex-wrap flex-row text-center justify-center w-full bg-[#232323] text-white text-[11px] leading-[17px] font-bold text-center px-0 pt-[4px] pb-[7px] overflow-hidden text-ellipsis bg-gradient-to-t from-[#232323] to-[#494949]">
                    Te Gjitha
                </h2>
                <div class="hiddenMatch flex items-center justify-between p-1 pb-0">
                    <div class="flex topHolder">
                        <div class="searchHolder w-full relative">
                            <div class="searchHeader relative">
                                <div class="relative w-full flex flex-wrap flex-row w-full">
                                    <img class="w-[14px] h-[14px] absolute left-1 top-[50%] -translate-y-1/2 pointer-none" src="~/../img/search.png" />
                                    <input type="text" id="findGame" class="searchInputLabel1 bg-[rgba(255,255,255,0.2)] border border-[rgba(255,255,255,0.4)] text-white h-[20px] text-[12px] pl-5" />

                                    <div class="helper1 absolute right-0 top-0 cursor-pointer w-[40px] h-[20px] z-10 hidden flex-wrap flex-row spasce-x-2 justify-between">
                                        <div class="closeSearch flex items-center w-[20px] h-[20px]">
                                            <span class="text-white text-[14px] w-[20px] leading-[20px] text-center font-bold">x</span>
                                        </div>
                                        <div class="closeSearch w-[20px] h-[20px]">
                                            <svg class="w-full h-full fill-white" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="icon" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
                                                <path d="M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,15H17.8  l3.6-3.6L20,10l-6,6l6,6l1.4-1.4L17.8,17H28v9H12V6h16V15z"/>
                                                <rect id="_x3C_Transparent_Rectangle_x3E__589_" class="st0" width="32" height="32"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="searchContent1 absolute w-auto left-0 top-[25px] bg-white z-10 h-auto max-h-[calc(100vh-178px)] overflow-y-scroll ease-in-out duration-100" id="searchContent1"></div>
                        </div>
                    </div>
                    <div class="flex items-center text-sm">
                        <span class="text-white text-[11px] mr-1">Rendit Sipas:</span>
                        <select class="w-[100px] leading-[10px] h-[17px] text-white text-[11px] bg-[#808080] bg-[url('./img/select-arrow.png')] bg-no-repeat bg-[90%_center] border-0 appearance-none text-indent-[0.01px] overflow-hidden rounded-none">
                            <option>Orës</option>
                        </select>
                    </div>
                </div>
                <div id="gamesLeagueWrapper" class="flex w-full flex-wrap flex-row">
                    <div data-game="${gameId}" class="flex flex-wrap flex-row w-full">
                        <div class="flex flex-wrap flex-row w-full bg-black/30 items-center"> 
                            <a class="backBtn prematchArrow  m-t-6 w-[30px] h-[28px] p-2 pr-3 border-r">
                                <svg class="h-full w-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path></svg>
                            </a>
                            <div class="singleMatchTitle prematchLabelArrow m-t-6 flex flex-1 flex-wrap flex-row w-full py-1 px-2 max-w-[calc(100%-30px)]">
                                <div class="singleMatchScrolLMeName flex flex-wrap flex-row text-[12px] text-white relative w-full">
                                    <div class="singleCategoryTitle flex-wrap flex-row w-full flex absolute left-0 top-0 justify-between">
                                        <span class="flex text-[10px] text-white/50">${matchSportName} / ${matchCountryName} </span>
                                        <span class="flex text-[10px] text-white/50">${
                                          groupMatchDate.split(":")[0]
                                        }:${groupMatchDate.split(":")[1]}</span>
                                    </div>
                                    <span class="matchVersusName font-bold pt-4">${groupMatchHomeName} vs ${groupMatchAwayName}</span>
                                </div>
                            </div>
                        </div>
                        <div class="singleMatchCatButtons flex flex-wrap flex-row w-full mt-2 mb-2">
                            <div class="scrollMe flex flex-row flex-nowrap overflow-x-scroll bg-gradient-to-b from-[#a90329] via-[#8f0222]" id="scrollMeContent">
                                ${scrollMeContent}
                            </div>
                        </div>
                    </div>
                    <div class="singleMatchSearchMarkets matchSingleMarketInput flex flex-wrap flex-row w-full mb-2 relative">
                        <img src="./img/search.png" class="absolute left-0 top-0 p-1 w-[20px] h-[20px]" />
                        <input type="text" id="searchMarketsId" class="bg-[rgba(255,255,255,0.2)] border border-[rgba(255,255,255,0.4)] text-white h-[20px] text-[12px] pl-5">
                    </div>
                    <div id="${gameId}-content" class="flex flex-row flex-wrap w-full">
                        ${groupMatchView}
                    </div>
                    <div id="emptyMessage" class="flex-wrap flex-row w-full hidden">
                        <div class="singleMatchBetModuleGroupHeader flex flex-wrap flex-row w-full text-[11px] leading-[19px] font-normal text-left text-yellow-400 bg-black/70 items-center justify-center justify-content mb-[1px] space-x-1 text-center">
                            <span class="titleMarketSearch justify-center justify-content flex flex-wrap flex-row pt-[1px] w-full">Nuk gjetem rezultat.</span>
                        </div>
                    </div>
                </div>
            </div>
       `;
    return view;
  },
  after_render: async (socket) => {
    if (blockedSportRedirect) return;

    setTimeout(() => {
      $("body .matchViewAll").removeClass("opacity-0");
    }, 200);

    $(document)
      .off("click.topHolder.searchclose", ".closeSearch")
      .on("click.topHolder.searchclose", ".closeSearch", function () {
        $("body .searchInputLabel1").val("");
        $("body .searchInputLabel1").blur();
        $("body #searchContent1").html("");
        $("body .helper1").removeClass("flex");
        $("body .helper1").addClass("hidden");
      });

    let searchTimeout;
    const findGameInput = document.getElementById("findGame");

    findGameInput.addEventListener("keyup", () => {
      clearTimeout(searchTimeout); // Clear previous timeout to debounce

      const bettingButtons = document.querySelectorAll(".bettingBtn");

      searchTimeout = setTimeout(async () => {
        // ✅ FIX: treat element vs value correctly
        const $inputEl = $("body .searchInputLabel1");
        const val = String($inputEl.val() || "");

        const $content = $("body #searchContent1");
        const $helper = $("body .helper1");

        // Reset when empty
        if (val.length === 0) {
          $inputEl.val("").blur();
          $content.html("");
          $helper.removeClass("flex").addClass("hidden");
          return;
        }

        // Only search when 2+ chars (kept your threshold)
        if (val.length < 2) return;

        try {
          const searchValues = await getSearchGames(val);

          if (!Array.isArray(searchValues) || searchValues.length === 0) {
            // No results
            $content.html(``);
            $helper.removeClass("flex").addClass("hidden");
            return;
          }

          // Get unique, sorted YYYY-MM-DD dates (lexicographic works for ISO)
          const uniqueDates = [
            ...new Set(searchValues.map((i) => i.game_date)),
          ].sort();

          let searchGamesView = "";

          uniqueDates.forEach((date) => {
            let singleDateView = "";

            const currentUrlIsLive = window.location.hash; // Get current hash URL
            const base = searchValues
              // skip invalid/excluded
              .filter((a) => a?.odd && a.id !== 372481 && a?.type_id != null); // require type_id

            base
              .filter((a) => Number(a.type_id) === 1)
              .forEach((a) => {
                if (a.game_date !== date) return;
                singleDateView += getSearchingGames(a, "1");
              });

            if (singleDateView) {
              searchGamesView += `
                  <div class="searchLabelGroup flex flex-wrap flex-row w-full">
                    <div class="search-games w-full space-y-2">
                      <ul>${singleDateView}</ul>
                    </div>
                  </div>
                `;
            }
          });

          // If all items were filtered out, show "no results"
          if (!searchGamesView) {
            $content.html(`
                            <div class="p-3 text-sm text-white/80 bg-black/40">
                            No matches for "<span class="font-semibold">${val}</span>".
                            </div>
                        `);
          } else {
            $content.html(searchGamesView);
          }

          // Open panel
          $helper.removeClass("hidden").addClass("flex");
        } catch (err) {
          console.error("Search error:", err);
          $content.html(`
                      <div class="p-3 text-sm text-red-300 bg-black/40">
                        Something went wrong while searching. Please try again.
                      </div>
                    `);
          $helper.removeClass("hidden").addClass("flex");
        }
      }, 300); // Delay of 300ms
    });

    // keep your original delay in case it's used elsewhere
    function delay(callback, ms) {
      var timer = 0;
      return function () {
        var context = this,
          args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          callback.apply(context, args);
        }, ms || 0);
      };
    }

    // ✅ NEW: small debounce helper for market search
    function debounce(fn, ms) {
      let t;
      return function (...args) {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), ms);
      };
    }

    // ✅ Reset state on (re)render to avoid stale hidden groups
    $("#searchMarketsId").val("");
    $("body .singleMatchBetModuleGroup").removeClass("hidden");
    $("body #emptyMessage").addClass("hidden");

    // ✅ Replace keyup+delay with namespaced input+debounce and robust DOM traversal
    $("body")
      .off("input.marketSearch", "#searchMarketsId")
      .on(
        "input.marketSearch",
        "#searchMarketsId",
        debounce(function () {
          const term = String($("#searchMarketsId").val() || "")
            .toLowerCase()
            .trim();

          if (!term) {
            $(".singleMatchBetModuleGroup").removeClass("hidden");
            $("#emptyMessage").addClass("hidden");
            return;
          }

          let hiddenCount = 0;

          $(".titleMarketSearch").each(function () {
            const txt = $(this).text().toLowerCase();
            const $group = $(this).closest(".singleMatchBetModuleGroup");
            if (txt.includes(term)) {
              $group.removeClass("hidden");
            } else {
              $group.addClass("hidden");
              hiddenCount++;
            }
          });

          if ($(".singleMatchBetModuleGroup").length === hiddenCount) {
            $("#emptyMessage").removeClass("hidden");
          } else {
            $("#emptyMessage").addClass("hidden");
          }
        }, 300)
      );

    //socket.emit('connectToRoom', {room: gameId});
    const event = new CustomEvent("addToRoom", {
      detail: gameId,
    });
    window.dispatchEvent(event);

    $(`body div[data-game=${gameId}] .singleMatchCatBtn`)
      .unbind("click")
      .on("click", function (e) {
        $("body .singleMatchCatBtn").removeClass("active");
        $("body .singleMatchBetModule").addClass("hidden");
        $("body .singleMatchBetModule").removeClass("flex");
        $("body .singleMatchCatButtons .singleMatchCatBtn").addClass(
          "text-white/50 bg-black/40 "
        );
        $("body .singleMatchCatButtons .singleMatchCatBtn").removeClass(
          "bg-[#81011e] "
        );
        $(e.currentTarget).removeClass("text-white/50 bg-black/40");
        $(e.currentTarget).addClass("active text-white bg-[#81011e]");

        let putTriggerContent = $(e.currentTarget).attr("data-target");
        console.log(e, putTriggerContent);
        $("body .singleMatchBetModule").each(function (i, item) {
          if ($(item).attr("data-content") == putTriggerContent) {
            $(item).removeClass("hidden");
            $(item).addClass("flex");
          }
        });
      });

    $("body .singleMatchBetModuleGroupContent").each(function (i, item) {
      if ($(item).children(".bettingBtn").length == 2) {
        $(item).addClass("column-2");
      }
    });

    $("body .singleMatchBetModuleGroupContent").each(function (i, item) {
      if (
        $(item).attr("id") === "19-content" ||
        $(item).attr("id") === "290-content" ||
        $(item).attr("id") === "342-content"
      ) {
        $(item).children(".bettingBtn").addClass("column-4");
        $(item).children().addClass("fourColumns");
      }
    });

    socket.on("new-coefs", (res) => {
      if (res.game_id == gameId) {
        const userGroup = getUserGroup();
        res.coefs.forEach((data) => {
          data = transformSingleCoef(data, userGroup);
          const market = document.getElementById(data.market_id);
          const marketContent = document.getElementById(
            data.market_id + "-content"
          );
          const newSingleCoefTemplate = getSingleColumnModule(
            {
              home_team: groupMatchHomeName,
              away_team: groupMatchAwayName,
              market_option: data.market_option_name,
              market: data.market_id,
              odd: data.odd,
              id: data.coef_id,
            },
            { id: data.game_id }
          );

          if (!market) {
            let mainContainer = document.getElementById(`${gameId}-content`);
            if (mainContainer) {
              mainContainer.innerHTML += `
                                <div class="singleMatchBetModuleGroup" id=${
                                  data.market_id
                                }>
                                    <div class="singleMatchBetModuleGroupHeader">
                                        <span class="titleMarketSearch">${_t(
                                          data.market_name
                                        )}</span>
                                    </div>
                                    <div class="singleMatchBetModuleGroupContent">
                                        ${newSingleCoefTemplate}
                                    </div>
                                </div>
                            `;
            }
          } else {
            var div = document.getElementsByClassName(data.coef_id)[0];
            if (div) {
              div.innerHTML = getInsideSingleColumn(
                data.market_option_name,
                data.odd
              );
            } else {
              marketContent.innerHTML += newSingleCoefTemplate;
            }
          }
        });
        updateMatch();
      }
    });

    let scrollWidth = 0;
    let scrollMeWidth = 0;

    scrollMeWidth += $("body .singleCategoryTitle").width();
    scrollMeWidth += $("body .matchVersusName").width();

    $(".singleMatchScrolLMeName").width(scrollMeWidth + 50);

    $("body .singleMatchCatBtn").each(function () {
      scrollWidth += $(this).width() + 21;
    });
    $("body .scrollMe").css({
      width: scrollWidth + "px",
    });
  },
  on_unload: async (socket) => {
    //socket.emit('leaveRoom', {room: gameId});
    const event = new CustomEvent("leaveRoom", {
      detail: gameId,
    });
    window.dispatchEvent(event);
  },
};

export default Match;
